import { Component, effect, Input } from '@angular/core';
import { PortalService } from '../../../core/services/portal.service';

export interface ProductItem {
  title: string;
  code: string;
  link: string;
  img: string;
  width: number;
  height: number;
}

@Component({
  selector: 'app-product-list',
  standalone: false,
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent {
  @Input() products: ProductItem[] = [];
  readonly productImageFallbackSrc = 'assets/images/fallback-logo.svg';
  primaryColor = ''
  constructor (private portalService: PortalService) {
    effect(() => {
      if (!this.portalService.loaded()) return;
      const portal = this.portalService.portal()!;
      this.primaryColor = portal.style.primary_color
    });
  }

  onProductImageError(event: Event): void {
    const target = event.target as HTMLImageElement | null;
    if (!target) {
      return;
    }

    const fallbackSrc = this.productImageFallbackSrc;
    const currentSrc = String(target.getAttribute('src') || target.src || '');
    if (currentSrc.includes(fallbackSrc)) {
      return;
    }

    target.src = fallbackSrc;
  }
}
